var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.625 2.75H12.75V4H11.5V12.125C11.5 12.2908 11.4342 12.4497 11.3169 12.5669C11.1997 12.6842 11.0408 12.75 10.875 12.75H2.125C1.95924 12.75 1.80027 12.6842 1.68306 12.5669C1.56585 12.4497 1.5 12.2908 1.5 12.125V4H0.25V2.75H3.375V0.875C3.375 0.70924 3.44085 0.550268 3.55806 0.433058C3.67527 0.315848 3.83424 0.25 4 0.25H9C9.16576 0.25 9.32473 0.315848 9.44194 0.433058C9.55915 0.550268 9.625 0.70924 9.625 0.875V2.75ZM10.25 4H2.75V11.5H10.25V4ZM4.625 5.875H5.875V9.625H4.625V5.875ZM7.125 5.875H8.375V9.625H7.125V5.875ZM4.625 1.5V2.75H8.375V1.5H4.625Z",
    fill: "#2E2E2E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.36accb618b4a3566b354d1e61d00ed68.svg";
export { ForwardRef as ReactComponent };